import React from "react";

export const QualityEvidence: React.FC = () => (
  <section className="evidence-panel" aria-labelledby="quality-evidence-title">
    <h2 id="quality-evidence-title">How the review workflow worked</h2>
    <p>
      This simplified reconstruction describes the documented QC approach. It
      contains no company data or internal screenshots.
    </p>
    <div className="quality-layers">
      <article>
        <h3>Check the files</h3>
        <p>
          Missing files, invalid JSON, broken images, or code that could not run
          triggered deterministic failure checks.
        </p>
        <span>Record the failure</span>
      </article>
      <article>
        <h3>Flag suspicious samples</h3>
        <p>
          Near-duplicate states and poor visual matches produced risk signals
          for a review queue.
        </p>
        <span>Queue for inspection</span>
      </article>
      <article>
        <h3>Review meaning and coverage</h3>
        <p>
          Multimodal review and human sampling checked action consistency,
          labeling, and visual fidelity. Stratified sampling examined supplier
          and batch patterns.
        </p>
        <span>Document the decision</span>
      </article>
    </div>
    <div className="evidence-example">
      <h3>A rule I changed</h3>
      <p>
        A browser-workflow check treated the maximum exportable frame count as
        the required number of screenshots. I challenged that assumption and
        checked the source requirements. The revised review used the actual
        deliverable requirements to assess coverage.
      </p>
    </div>
    <details>
      <summary>Demo backtest recorded in the work archive</summary>
      <div className="table-scroll">
        <table>
          <caption>
            Results under the corrected QC rules; these demo sets have different
            requirements.
          </caption>
          <thead>
            <tr>
              <th scope="col">Format</th>
              <th scope="col">Passed</th>
              <th scope="col">Review context</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Browser flow</th>
              <td>14 / 16</td>
              <td>
                Failures included blank, loading, or error-page screenshots.
              </td>
            </tr>
            <tr>
              <th scope="row">Image2Code</th>
              <td>4 / 5</td>
              <td>
                An empty trajectory-thinking stage failed; a visual result also
                required review.
              </td>
            </tr>
            <tr>
              <th scope="row">Figma</th>
              <td>9 / 9</td>
              <td>
                Warnings remained for issues such as image coverage and
                resolution.
              </td>
            </tr>
            <tr>
              <th scope="row">Sketch</th>
              <td>20 / 20</td>
              <td>
                Coverage rules were corrected from artboard-level to page-level
                matching.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </details>
  </section>
);

export const ForecastEvidence: React.FC = () => (
  <section className="evidence-panel" aria-labelledby="forecast-evidence-title">
    <h2 id="forecast-evidence-title">Reading the forecasting result</h2>
    <dl className="evaluation-facts">
      <div>
        <dt>Comparison</dt>
        <dd>ARIMA, XGBoost, and LightGBM</dd>
      </div>
      <div>
        <dt>Validation</dt>
        <dd>Rolling-window backtesting across three pilot sites</dd>
      </div>
      <div>
        <dt>Inputs I engineered</dt>
        <dd>Load lags, rolling means, and calendar features</dd>
      </div>
      <div>
        <dt>Reported outcome</dt>
        <dd>MAPE from 9.3% to 5.6%</dd>
      </div>
    </dl>
    <p>
      The change is 3.7 percentage points, or approximately 40% relative to the
      starting error. The reported values summarize pilot validation; individual
      site results and the original forecast series are not included here.
    </p>
  </section>
);
